import React, {useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Input, Select, ListItemText, FormControl, MenuItem, createStyles, Theme as AugmentedTheme, InputLabel} from '@material-ui/core';
import { CustomInputMappingField } from '@tuqqi/common';


interface ISelect {
    field: CustomInputMappingField,
    multipleValues: string[],
    multipleSelectChangeHandler: (val: string[]) => void,
    isRtl: boolean
}

const useStyles = makeStyles((theme: AugmentedTheme) =>  createStyles({
    select: {
        position: 'relative',
        width: '100%',
        padding: '8px 10px'
    },
    optionsList: {
        paddingTop: 2.5,
        paddingBottom: 2.5
    },
//@ts-ignore
inputLabel: {
    ...theme.inputLabel,
    color: '#202124!important'
},
//@ts-ignore
requiredLabel: {
    ...theme.requiredLabel,
    color: '#202124!important'
},
//@ts-ignore
requiredField: theme.requiredField,
placeholder: {
    color: 'rgb(133, 133, 133)!important',
},
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: '-webkit-fill-available',
        [theme.breakpoints.down('sm')]: {
            minWidth: 'unset!important',
        }
    },
}))

export default function MultiSelect({ field, multipleValues, multipleSelectChangeHandler,isRtl }: ISelect) {
    const classes = useStyles();

    const [options, setOptions] = useState<string[]>(['']);
    const [isFocused, setIsFocused] = useState(false);

    const handleChangeMultiple = (e: React.ChangeEvent<{ value: unknown }>) => {
        multipleSelectChangeHandler(e.target.value as string[]);
    }

    useEffect(() => {
        if(field.options) {
            const selectOptions = field.options?.split(';');
            setOptions(selectOptions);
        }
    }, [field.options])

    const isEmpty = !multipleValues || multipleValues.length === 0
    const showRequired = field.required && isEmpty
    const showErrorBorder = (field.required && isEmpty) || (isFocused && isEmpty)

    return(
        <FormControl className={classes.formControl}>
            <InputLabel 
                        style={{ 
                            direction: isRtl ? 'rtl' : 'ltr',
                            textAlign: isRtl ? 'right' : 'left' 
                        }} 
                        htmlFor={field.sourceField} className={showRequired ? classes.requiredLabel : classes.inputLabel}>{field.fieldName}</InputLabel>
            <Select
             style={{ 
                direction: isRtl ? 'rtl' : 'ltr',
                textAlign: isRtl ? 'right' : 'left' 
            }} 
                multiple
                displayEmpty
                value={multipleValues}
                onChange={handleChangeMultiple}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                required={field.required}
                input={<Input />}
                classes={{ select: `${classes.select} ${!multipleValues.length ? classes.placeholder : ""} ${showErrorBorder ? classes.requiredField : ''}` }}
                MenuProps={{classes: {list: classes.optionsList}}}   
                renderValue={(selected:any) => {
                    if (selected.length === 0) {
                    // return <span>{field.fieldName}</span>;
                    return <span style={{color: 'rgb(133, 133, 133)!important',}}>{"Select"}</span>
                    }

                    return selected.join(', ');
                }}
                inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MenuItem
                     style={{ 
                        direction: isRtl ? 'rtl' : 'ltr',
                        textAlign: isRtl ? 'right' : 'left' ,
                        color: 'rgb(133, 133, 133)!important',
                    }} 
                     disabled value="">
                    {`Select`}
                    </MenuItem>
                    {options.map((item: any) => (
                        <MenuItem 
                        style={{ 
                            direction: isRtl ? 'rtl' : 'ltr',
                            textAlign: isRtl ? 'right' : 'left' 
                        }} 
                        key={item.trim()} value={item.trim()}>
                            <ListItemText 
                             style={{ 
                                direction: isRtl ? 'rtl' : 'ltr',
                                textAlign: isRtl ? 'right' : 'left' 
                            }} 
                            primary={item} />
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    )
}
